import axiosInstance from '../index';

export const getScoreCardConfigData = () => {
  return axiosInstance.get(`api/elastic/scorecard_config`);
};

export const getReportingData = (reportingData, signal) => {
  return axiosInstance.post(`api/elastic/scorecard`, reportingData, {
    signal: signal
  });
};

export const getDownloadReport = (downloadreport) => {
  return axiosInstance.post(`api/elastic/scorecard_download_report`, downloadreport, {
    responseType: 'blob'
  });
};

export const scorecardFeatureWiseGraph = (parmas) => {
  return axiosInstance.post(`api/elastic/scorecard_feature_wise_graph`, parmas);
};

export const getReportingTeamColumnData = (params) => {
  return axiosInstance.post(`api/elastic/get_scorecard_add_columns_base_on_team`, params);
};
